import moment from 'moment';

export function getCallDataOneOnOne({
  everyBodyJoined,
  iDeclined,
  actorWasMe,
  partner = {person: {displayName: ''}},
  partnerDeclined
}) {
  let arg, status;

  if (everyBodyJoined) {
    status = 'youHadACall';
  }
  // One on One Call
  else if (iDeclined) {
    status = 'youCancelledACall';
  }
  else if (partnerDeclined) {
    status = 'someoneCancelledACall';
    arg = {name: partner.person.displayName};
  }
  else if (actorWasMe) {
    status = 'someoneWasUnavailable';
    arg = {name: partner.person.displayName};
  }
  else {
    status = 'youMissedACall';
  }

  return {arg, status};
}

function getCallDataGroup({
  iWasJoined,
  noBodyJoined,
  actorWasMe,
  actor = {displayName: ''}
}) {
  let arg, status;

  if (iWasJoined && !noBodyJoined) {
    status = 'youHadAMeeting';
  }
  else if (noBodyJoined) {
    if (actorWasMe) {
      status = 'nobodyJoinedYourMeeting';
    }
    else {
      status = 'nobodyJoinedTheMeeting';
    }
    arg = {name: actor.displayName};
  }
  else {
    status = 'youMissedAMeeting';
  }

  return {arg, status};
}


/**
 * Parses call data from an activity
 * @param {object} callData
 * @param {object} callData.actor
 * @param {number} callData.duration
 * @param {boolean} callData.isGroupCall
 * @param {array} callData.participants
 * @param {object} currentUser
 * @returns {object}
 */
export function parseActivityCallData(callData, currentUser) {
  const {
    actor = {displayName: ''},
    duration,
    isGroupCall,
    participants
  } = callData;
  // Call/Meeting update parsing
  const partner = participants.find((p) => p.person.entryUUID !== currentUser.id);
  const me = participants.find((p) => p.person.entryUUID === currentUser.id);

  const iWasJoined = me && me.state === 'LEFT';
  const iDeclined = me && me.state === 'DECLINED';
  const partnerDeclined = partner && partner.state === 'DECLINED';
  const everyBodyJoined = participants.every((p) => p.state === 'LEFT');

  const callees = participants.filter((p) => !p.isInitiator);
  const noBodyJoined = callees.every((p) => p.state !== 'LEFT');

  const actorWasMe = actor && actor.id === currentUser.id;

  const {arg, status} = isGroupCall
    ? getCallDataGroup({
      iWasJoined,
      noBodyJoined,
      actorWasMe,
      actor
    })
    : getCallDataOneOnOne({
      everyBodyJoined,
      iDeclined,
      actorWasMe,
      partner,
      partnerDeclined
    });

  // Duration
  const humanizedDuration = moment.duration((duration || 0) * 1000).humanize();

  return {
    callInfo: {
      duration: humanizedDuration,
      ...arg
    },
    status
  };
}
